import reportTypes, { ReportTypes } from './reportTypes';

export const ENTITY_REPORT_GENERATING_MESSAGE = 'Your report is being generated';

export const DEFAULT_REPORT_GENERATION_FAILED_MESSAGE = 'The report generation failed. Please retry again.';

export const ENTITY_REPORT_AVAILABILITY_NOTE = [
  'Please note that newly created entities become available for Entity Report extraction',
  'starting the afternoon of the following day.',
].join(' ');

export const getReportGenerationFailedMessage = (reportType: ReportTypes) => (
  reportType === reportTypes.ENTITY_REPORT
    ? `${DEFAULT_REPORT_GENERATION_FAILED_MESSAGE} ${ENTITY_REPORT_AVAILABILITY_NOTE}`
    : DEFAULT_REPORT_GENERATION_FAILED_MESSAGE
);
